type DROPDOWN_PLACEMENT =
  | 'top'
  | 'top left'
  | 'top right'
  | 'bottom'
  | 'bottom left'
  | 'bottom right'
  | 'left'
  | 'right';

export interface INbDropdownItem {
  isDivider?: boolean;
  children?: INbDropdownItem[];
  [key: string]: any;
}

export interface INbDropdownOptions {
  placeholder?: string;
  autoClose?: boolean;
  fullWidth?: boolean;
  closeOnClick?: boolean;
  placement?: DROPDOWN_PLACEMENT;
  appendToBody?: boolean;
  labelField?: string;
  valueField?: string;
  itemClass?: string[];
  isDisabled?: boolean;
}

export const defaultOptions: INbDropdownOptions = {
  placeholder: 'Select...',
  autoClose: true,
  fullWidth: false,
  closeOnClick: true,
  placement: 'bottom left',
  appendToBody: false,
  labelField: 'label',
  valueField: 'value',
  itemClass: [],
  isDisabled: false,
};
